import mainApiClient from '../clients/mainApiClient';
import { API_ENDPOINTS } from '../endpoints';

function buildIdParams(id) {
  return {
    _id: id,
  };
}

export const cardsApi = {
  getAll({ limit, lastId, last_id } = {}) {
    return mainApiClient.get(API_ENDPOINTS.cards.view.getAll, {
      auth: true,
      params: {
        limit,
        last_id: lastId ?? last_id,
      },
    });
  },

  getById({ id, _id } = {}) {
    return mainApiClient.get(API_ENDPOINTS.cards.view.getById, {
      auth: true,
      params: buildIdParams(id ?? _id),
    });
  },

  revealSecretData({ id, _id } = {}) {
    return mainApiClient.post(
      API_ENDPOINTS.cards.view.revealSecretData,
      undefined,
      {
        auth: true,
        params: buildIdParams(id ?? _id),
      }
    );
  },

  getDepositOperations({ id, _id, addressId, address_id } = {}) {
    return mainApiClient.get(API_ENDPOINTS.cards.view.getDepositOperations, {
      auth: true,
      params: {
        _id: id ?? _id,
        address_id: addressId ?? address_id,
      },
    });
  },

  create({
    cardStyle,
    card_style,
    cardName,
    card_name,
    fullName,
    full_name,
    cardType,
    card_type,
    data,
  } = {}) {
    return mainApiClient.post(
      API_ENDPOINTS.cards.manage.create,
      data ?? {
        card_style: cardStyle ?? card_style,
        card_name: cardName ?? card_name,
        full_name: fullName ?? full_name,
        card_type: cardType ?? card_type,
      },
      {
        auth: true,
      }
    );
  },

  getDepositAddress({
    id,
    _id,
    currencyId,
    currency_id,
    network,
    data,
  } = {}) {
    return mainApiClient.post(
      API_ENDPOINTS.cards.manage.getDepositAddress,
      data ?? {
        _id: id ?? _id,
        currency_id: currencyId ?? currency_id,
        network,
      },
      {
        auth: true,
      }
    );
  },

  updateDetails({ id, _id, setData, set_data, unsetData, unset_data, data } = {}) {
    return mainApiClient.patch(
      API_ENDPOINTS.cards.manage.updateDetails,
      data ?? {
        _id: id ?? _id,
        set_data: setData ?? set_data ?? {},
        unset_data: unsetData ?? unset_data ?? {},
      },
      {
        auth: true,
      }
    );
  },

  updateStatus({ id, _id, status, data } = {}) {
    return mainApiClient.patch(
      API_ENDPOINTS.cards.manage.updateStatus,
      data ?? {
        _id: id ?? _id,
        status,
      },
      {
        auth: true,
      }
    );
  },

  updatePinCode({ id, _id, pinCode, pin_code, data } = {}) {
    return mainApiClient.patch(
      API_ENDPOINTS.cards.manage.updatePinCode,
      data ?? {
        _id: id ?? _id,
        pin_code: pinCode ?? pin_code,
      },
      {
        auth: true,
      }
    );
  },
};
